import { Component, OnInit } from '@angular/core';
import { SurveyServiceService } from '../../services/SurveyService.service';
import { PatientServiceService } from '../../services/PatientService.service';

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.css']
})
export class PaSurveyComponent implements OnInit {
  htmlView: boolean = true;
  errHeader: string;
  errMessage: string[] = [];
  currentListShow:boolean=false;
  showFeedback = false;
  showOverlaySurvey: boolean;
  caseList: any[];
  constructor(private _service: SurveyServiceService,private serv:PatientServiceService) { }

  ngOnInit() {

    this.getSurveyList();
  }

  getSurveyList() {
    this.showOverlaySurvey = true;
    this._service.getSurveyList().subscribe((data:any[]) => {
      this.caseList = data;
      this.currentListShow = this.caseList.length < 1 ? true : false;
    }, err => {
      if (err.status === 400) {
        this.errHeader = 'Server Exception';
        this.errMessage = err.error;
        this.htmlView = false;
        this.showOverlaySurvey = false;
      }
    }, () => { this.htmlView = true;  this.showOverlaySurvey = false; });
  }

  goToSurvey(linkCode){
    var url='SurveyViaLink?LinkCode='+linkCode.trim();
    window.open(url,'_blank');
  }
}
